<template>
  <div class="map bg-light_gray">
    <div
      v-show="showMapPanel || showSearchPanel"
      class="z-10 w-full"
      :class="showMapPanel ? 'absolute' : 'sticky'">
      <search-form
        @search="onSearch"
        @incrementSearch="onIncrementSearch"
        @closeSearchPanel="onCloseSearchPanel"
        @openFilterPanel="onOpenFilterPanel"
        :onSearch="showSearchPanel"
      />
    </div>
    <div v-show="showMapPanel" class="h-full w-full">
      <map-panel
        @search="onSearch"
        @closeSearchPanel="onCloseSearchPanel"
        @openFilterPanel="onOpenFilterPanel"
        :showSearchPanel="showSearchPanel"
      />
    </div>
    <div v-show="showSearchPanel" class="h-full w-full pb-4">
      <search-panel
        @openGenreList="onOpenGenreList"
        @selectGenre="onSelectGenre"
        :genre="genre"
        :searchWord="searchWord"
      />
    </div>
    <div v-show="showGenreList" class="h-full w-full pb-4">
      <genre-list
        @close="onCloseGenreList"
        @selectGenre="onSelectGenre"
      />
    </div>
    <div v-show="showFilterPanel" class="h-full w-full pb-4">
      <filter-panel
        @close="onCloseFilterPanel"
      />
    </div>
    <div v-show="showDocomoMobaku" class="h-full w-full pb-4">
      <docomo-mobaku/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import SearchForm from '../components/organisms/Map/SearchForm'
import SearchPanel from '../components/organisms/Map/SearchPanel'
import GenreList from '../components/organisms/Map/GenreList'
import FilterPanel from '../components/organisms/Map/FilterPanel'
import MapPanel from '../components/organisms/Map/MapPanel'
import DocomoMobaku from '../components/organisms/Map/DocomoMobaku'

export default {
  beforeRouteEnter (route, redirect, next) {
    const p = {
      name: redirect.name,
      params: redirect.params,
      route: route.params.route
    }
    next((vm) => {
      vm.$store.dispatch('map/updateFrom', p)
      if (p.route) {
        const fromLocation = p.route.points[0].location
        const center = {
          lat: fromLocation.latitude,
          lng: fromLocation.longitude
        }
        vm.$store.dispatch('map/updateCenter', center)
      }
    })
  },
  created () {
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('places/fetchAll')
      .then(() => {
        if (this.$route.params.tagId !== undefined) {
          this.$store.dispatch('user/onFilterFromTag', this.$route.params.tagId)
        } else {
          const place = this.$store.getters['places/getPlace'](this.$route.params.poiId)
          if (place) {
            this.$store.dispatch('map/openPlace', { place: place, full: true })
          } else {
            this.$store.dispatch('map/updateSelectedPlace', {})
          }
        }
        if (this.token) {
          this.$store.dispatch('favorites/fetchAll').then(() => {
            const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
            if (favoriteGenre !== undefined) {
              const favorites = this.$store.getters['favorites/getFavorites']
              for (var i = 0; i < favorites.length; i++) {
                this.$store.dispatch('places/updateFavoritePlace', { id: favorites[i], favoriteId: favoriteGenre.id, favorited: true, favoriteIcon: favoriteGenre.filterIcon})
              }
            }
          })
        }
      })
      .finally(() => {
        this.$store.dispatch('loading/endLoading')
      })
  },
  components: {
    SearchForm,
    SearchPanel,
    GenreList,
    FilterPanel,
    MapPanel,
    DocomoMobaku
  },
  data () {
    return {
      showMapPanel: true,
      showSearchPanel: false,
      showGenreList: false,
      showFilterPanel: false,
      showDocomoMobaku: false,
      genre: {},
      searchWord: '',
      mobakuMessage: false
    }
  },
  methods: {
    onSearch: function () {
      this.showSearchPanel = true
      this.showPlaceList = false
      this.showMapPanel = false
    },
    onCloseSearchPanel: function () {
      this.showSearchPanel = false
      this.showMapPanel = true
      this.genre = {}
    },
    onOpenGenreList: function () {
      this.showMapPanel = false
      this.showSearchPanel = false
      this.showGenreList = true
    },
    onCloseGenreList: function () {
      this.showGenreList = false
      this.showSearchPanel = true
    },
    onOpenFilterPanel: function () {
      this.showFilterPanel = true
      this.showSearchPanel = false
      this.showMapPanel = false
    },
    onCloseFilterPanel: function () {
      this.showMapPanel = true
      this.showFilterPanel = false
      var genres = this.$store.getters['user/getFilter']
      if (genres["mobaku"]) {
        this.$store.dispatch('googleMap/onDocomoMobaku')
        if(!this.mobakuMessage){
          this.mobakuMessage = true
          this.$store.dispatch('map/setShowDocomoMobaku', true)
        }
      } else {
        this.$store.dispatch('googleMap/offDocomoMobaku')
        this.mobakuMessage = false
      }
    },
    onSelectGenre: function (genre) {
      this.genre = genre
      this.showGenreList = false
      this.showSearchPanel = true
    },
    onIncrementSearch: function (word) {
      this.searchWord = word
    }
  },
  computed: {
    ...mapGetters({
      selectedPlace: 'map/getSelectedPlace',
      token: 'user/getToken',
      docomoMobakuOn: 'map/getShowDocomoMobaku',
    })
  },
  watch: {
    selectedPlace: function (val) {
      if (!_.isEmpty(val)) {
        this.showSearchPanel = false
        this.showMapPanel = true
      }
    },
    docomoMobakuOn: function (val) {
      this.showDocomoMobaku = val
    }
  }
}
</script>
